import { create } from 'zustand';

interface AudienceJoinCountState {
  count: number;
  setCount: (newCount: number) => void;
  setCountIfHigher: (newCount: number) => void;
}

export const useAudienceJoinCountStore = create<AudienceJoinCountState>(
  (set) => ({
    count: 0,
    setCount: (newCount: number) => set({ count: newCount }),
    setCountIfHigher: (newCount: number) =>
      set(({ count }) => ({ count: Math.max(count, newCount) })),
  }),
);
